import layout from '@/layout'

export default {
  path: '/hsgt',
  component: layout,
  redirect: '/hsgt/lgt_one_plus',
  name: 'hsgtLgtOnePlus',
  meta: {
    title: 'hsgt',
    icon: 'hsgt'
  },
  children: [
    {
      path: '/hsgt/lgt_one_plus',
      name: 'hsgtLgtOnePlus',
      component: () => import('@/views/lgt/one_plus'),
      meta: {
        title: 'hsgtLgtOnePlus',
        icon: 'hsgt_lgt'
      }
    }
  ]
}
